import { createContext, useContext, useMemo, useState } from 'react';
import type { GroupType } from '../../utils/enums';

type CreateHoldingStatementCtxState = {
  groupIds: Set<number>;
  setGroupIds: (set: Set<number>) => void;

  userIds: Set<number>;
  setUserIds: (set: Set<number>) => void;

  selectedGroupType: GroupType[];
  setSelectedGroupType: React.Dispatch<React.SetStateAction<GroupType[]>>;

  subject: string;
  setSubject: React.Dispatch<React.SetStateAction<string>>;
};

const CreateHoldingStatementCtxDefualtValue: CreateHoldingStatementCtxState = {
  groupIds: new Set(),
  userIds: new Set(),
  subject: '',

  setGroupIds: () => {},
  setUserIds: () => {},
  setSubject: () => {},

  selectedGroupType: [],
  setSelectedGroupType: () => {},
};

const CreateHoldingStatementCtx = createContext<CreateHoldingStatementCtxState>(
  CreateHoldingStatementCtxDefualtValue
);

export const useCreateHoldingStatementCtx = () => useContext(CreateHoldingStatementCtx);

type CreateHoldingStatementCtxProviderProps = {
  children: React.ReactNode;
};
export const CreateHoldingStatementCtxProvider = (
  props: CreateHoldingStatementCtxProviderProps
) => {
  const { children } = props;

  const [groupIds, setGroupIds]: [Set<number>, (set: Set<number>) => void] = useState(new Set());

  const [userIds, setUserIds]: [Set<number>, (set: Set<number>) => void] = useState(new Set());

  const [selectedGroupType, setSelectedGroupType] = useState<GroupType[]>([]);

  const [subject, setSubject] = useState<string>('');

  const value = useMemo(
    () => ({
      groupIds,
      userIds,
      selectedGroupType,
      subject,

      setGroupIds,
      setUserIds,
      setSelectedGroupType,
      setSubject,
    }),
    [groupIds, userIds, selectedGroupType, subject]
  );
  return (
    <CreateHoldingStatementCtx.Provider value={value}>
      {children}
    </CreateHoldingStatementCtx.Provider>
  );
};
